const Helper = {
  // 工具方法
  tool: {
    // 时间格式化
    formatTime(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const hour = date.getHours().toString().padStart(2, '0')
      const minute = date.getMinutes().toString().padStart(2, '0')
      const second = date.getSeconds().toString().padStart(2, '0')
      
      return format
        .replace('YYYY', year)
        .replace('MM', month)
        .replace('DD', day)
        .replace('HH', hour)
        .replace('mm', minute)
        .replace('ss', second)
    },
    // 金额格式化
    formatMoney(number, decimals = 2) {
      if (isNaN(number)) return '0.00'
      return Number(number).toFixed(decimals)
    },
    // PC端打开URL
    openUrl(url) {
      // PC端直接使用window.open打开新标签
      window.open(url, '_blank')
    },
    // PC端复制文本
    copyText(text) {
      // 使用原生Clipboard API
      navigator.clipboard.writeText(text)
        .then(() => {
          // 创建一个临时的Toast提示
          const toast = document.createElement('div')
          toast.textContent = '复制成功'
          toast.style.position = 'fixed'
          toast.style.bottom = '20px'
          toast.style.left = '50%'
          toast.style.transform = 'translateX(-50%)'
          toast.style.padding = '10px 20px'
          toast.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
          toast.style.color = 'white'
          toast.style.borderRadius = '4px'
          toast.style.zIndex = '9999'
          
          document.body.appendChild(toast)
          
          // 2秒后移除
          setTimeout(() => {
            document.body.removeChild(toast)
          }, 2000)
        })
        .catch(err => {
          console.error('复制失败:', err)
        })
    },
    // PC端通知提示（替代uni.showToast）
    showToast(options) {
      const { title, duration = 2000, icon = 'none' } = options || {}
      
      // 创建一个临时的Toast提示
      const toast = document.createElement('div')
      toast.textContent = title || ''
      toast.style.position = 'fixed'
      toast.style.bottom = '20px'
      toast.style.left = '50%'
      toast.style.transform = 'translateX(-50%)'
      toast.style.padding = '10px 20px'
      toast.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
      toast.style.color = 'white'
      toast.style.borderRadius = '4px'
      toast.style.zIndex = '9999'
      
      // 如果是成功图标，可以添加一个简单的样式
      if (icon === 'success') {
        toast.style.borderLeft = '4px solid #07c160'
      }
      
      document.body.appendChild(toast)
      
      // 指定时间后移除
      setTimeout(() => {
        document.body.removeChild(toast)
      }, duration)
    }
  },
}

export default Helper 